export const ROLES = {
  ADMIN: 'admin',
  SENIOR_ACCOUNTANT: 'senior_accountant',
  ORDER_PROCESSOR: 'order_processor',
  DELIVERY_COORDINATOR: 'delivery_coordinator',
  VIEWER: 'viewer',
};

const PAGE_ACCESS = {
  '/dashboard':   ['admin', 'senior_accountant', 'viewer'],
  '/finance':     ['admin', 'senior_accountant', 'viewer'],
  '/inventory':   ['admin', 'senior_accountant', 'order_processor', 'viewer'],
  '/invoicing':   ['admin', 'senior_accountant', 'delivery_coordinator', 'viewer'],
  '/hrm':         ['admin', 'senior_accountant', 'viewer'],
  '/outsourcing': ['admin', 'senior_accountant', 'viewer'],
  '/reports':     ['admin', 'senior_accountant', 'viewer'],
  '/settings':    ['admin'],
};

export const canAccessPage = (role, path) => {
  if (!role || !path) return false;
  const basePath = '/' + path.split('/')[1];
  return PAGE_ACCESS[basePath]?.includes(role) ?? false;
};

export const getDefaultRedirect = (role) => {
  if (role === 'order_processor') return '/inventory';
  if (role === 'delivery_coordinator') return '/invoicing';
  return '/dashboard';
};

export const canDelete = (role) => role === 'admin';
export const canWrite = (role) => role !== 'viewer';
export const canSeePrice = (role) => role !== 'order_processor';
export const canEditOrder = (role) => ['admin', 'senior_accountant'].includes(role);
export const canAccessInvoicesTab = (role) => role !== 'delivery_coordinator';
